import "../../css/login.css";

import {
  Button,
  Grow,
  Paper,
  Popper,
  Typography,
  MenuList,
  MenuItem,
  ListItemIcon,
  ClickAwayListener,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component, useState, useRef } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Cookies } from "react-cookie";
import { styles } from "./style.js";
import { MasspaLanguage, TokenExpires, Token } from "../../utils/setting";
import "../../css/login.css";
const cookie = new Cookies();
const useStyles = makeStyles((theme) => ({
  right: {
    // position: 'absolute',
    // right: '0px',
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  flag: {
    border: "solid #fff 2px",
    borderRadius: "50%",
    // width: '1.5rem'
    height: "auto",
    width: "100%",
  },
  buttonItem: {
    backgroundColor: "#fff",
    // backgroundColor: '#0000000a',
    color: "#263238",
    fontSize: "0.8rem",
    textTransform: "capitalize",
    width: "143px",
  },
  buttonItemHeader: {
    backgroundColor: "#0000000a",
    color: "#ffffff",
    fontSize: "0.8rem",
    textTransform: "capitalize",
    width: "143px",
  },
  buttonLanguage: {
    margin: "16px 16px",
    padding: "0px",
    width: "143px",
  },
  menuItem: {
    fontSize: "0.8rem",
  },
  rootListItemIcon: {
    width: "28px",
    height: "28px",
    minWidth: "0",
    marginRight: "12px",
  },
}));
function ChangeLanguage(props) {
  // Declare a new state variable, which we'll call "count"
  let inputEl = useRef(null);
  const { i18n, header } = props;
  const classes = useStyles();
  const [anchorElLanguage, setAnchorElLanguage] = useState(null);
  const openMenuLanguage = Boolean(anchorElLanguage);
  function handleCloseLanguage() {
    setAnchorElLanguage(null);
    // setOpenMenuLanguage(false);
  }
  function changeLanguage(lang) {
    i18n.changeLanguage(lang);
    handleCloseLanguage();
    cookie.set(MasspaLanguage, lang, {
      path: "/",
      expires: new Date(Date.now() + TokenExpires),
    });
  }
  function handleToggleLanguage(event) {
    event.preventDefault();
    setAnchorElLanguage(anchorElLanguage ? null : event.currentTarget);
  }
  return (
    <div className={classes.right}>
      <Button
        // buttonRef={(node) => {
        //   inputEl = node;
        // }}
        className={classes.buttonLanguage}
        aria-controls="menu-list-grow"
        aria-haspopup="true"
        onClick={handleToggleLanguage}
      >
        {i18n.language === "vn" ? (
          <MenuItem
            className={header ? classes.buttonItemHeader : classes.buttonItem}
          >
            <ListItemIcon className={classes.rootListItemIcon}>
              <img src={"/images/vn_flag.png"} className={classes.flag} />
            </ListItemIcon>
            <Typography variant="inherit">Vietnamese</Typography>
          </MenuItem>
        ) : (
            <MenuItem
              className={header ? classes.buttonItemHeader : classes.buttonItem}
            >
              <ListItemIcon className={classes.rootListItemIcon}>
                <img src={"/images/uk_flag.png"} className={classes.flag} />
              </ListItemIcon>
              <Typography variant="inherit">English</Typography>
            </MenuItem>
          )}
      </Button>
      <Popper
        open={openMenuLanguage}
        anchorEl={anchorElLanguage}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper id="menu-list-grow">
              <ClickAwayListener onClickAway={handleCloseLanguage}>
                <MenuList>
                  <MenuItem
                    className={classes.menuItem}
                    onClick={() => changeLanguage("vn")}
                  >
                    <ListItemIcon className={classes.rootListItemIcon}>
                      <img
                        src={"/images/vn_flag.png"}
                        className={classes.flag}
                      />
                    </ListItemIcon>
                    <Typography variant="inherit">Vietnamese</Typography>
                  </MenuItem>
                  <MenuItem
                    className={classes.menuItem}
                    onClick={() => changeLanguage("en")}
                  >
                    <ListItemIcon className={classes.rootListItemIcon}>
                      <img
                        src={"/images/uk_flag.png"}
                        className={classes.flag}
                      />
                    </ListItemIcon>
                    <Typography variant="inherit">English</Typography>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
export default translate("translations")(ChangeLanguage);